import Character from "@lss/common/src/shell/Character";
import { v1JoeBeachQuestions } from "../../src/shell/PropertiesDeclarations";

interface ChrisPropertiesINT {
}

const chrisProperties: ChrisPropertiesINT = {
  
};


const chris = new Character<ChrisPropertiesINT>("Chris", chrisProperties, "#6391FFFF");

export {
    chris,
};